import moment from 'moment-timezone';

/**
 * Formats a date as relative time (e.g., "26 years ago", "3 months ago").
 *
 * @param {string|Date|number} date - The date value to format.
 * @param {string} [timezone] - Optional timezone for localization.
 * @returns {string} A relative time string or '-' if the date is invalid.
 */
export const formatRelativeDate = (date, timezone) => {
    if (!date) return '-';

    try {
        const momentDate = timezone ? moment.utc(date).tz(timezone) : moment.utc(date);

        if (!momentDate.isValid()) return '-';

        // Temporarily use floor rounding for more intuitive relative times,
        // then restore the default to avoid affecting other moment.fromNow() calls.
        const defaultRounding = moment.relativeTimeRounding();
        moment.relativeTimeRounding(Math.floor);
        const result = momentDate.fromNow();
        moment.relativeTimeRounding(defaultRounding);

        return result;
    } catch (error) {
        return '-';
    }
};
